import { Box, Collapse, Stack } from '@mui/material'
import AIResponseLog from '@/components/ChatResponseElements/AIResponseLog'
import { AgentThoughtSummaryLine } from './AgentThoughtSummaryLine'
import { AgentThoughtTracePanel } from './AgentThoughtTracePanel'
import { buildAgentReplyPreambleLead } from './buildAgentReplyPreambleLead.jsx'



export default function AgentReplyPreambleView({
  sx: sxProp,
  tracePanelId,
  details,
  workflowSteps,
  workflowStatus,
  hasTrace,
  hasInlineDetails,
  interactive,
  rowAlign,
  rowGap,
  thoughtSummary,
  thoughtStreaming = false,
  expanded,
  showLeadIcon,
  onToggleExpand,
}) {
  const lead = buildAgentReplyPreambleLead({
    showLeadIcon,
    interactive,
    expanded,
    tracePanelId,
    onToggleExpand,
  })

  return (
    <Stack
      alignItems="flex-start"
      alignSelf="stretch"
      sx={{ width: '100%', pt: '2px', gap: 1, boxSizing: 'border-box', ...sxProp }}
    >
      <Box sx={{ width: '100%', py: '4px', borderRadius: 'var(--app-radius-md)', boxSizing: 'border-box' }}>
        <Stack sx={{ width: '100%', minWidth: 0, gap: 0.25, alignItems: 'stretch' }}>
          <Stack direction="row" alignItems={rowAlign} sx={{ width: '100%', gap: rowGap, minWidth: 0 }}>
            <AgentThoughtSummaryLine>{thoughtSummary}</AgentThoughtSummaryLine>
            {lead}
          </Stack>
          {hasInlineDetails ? (
            <Box sx={{ width: '100%', minWidth: 0, pt: 0.5 }}>
              <AgentThoughtTracePanel paragraphs={details} streaming={thoughtStreaming} />
            </Box>
          ) : null}
          {hasTrace ? (
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Stack
                  id={tracePanelId}
                  sx={{ width: '100%', minWidth: 0, pt: 0.5, gap: 0.5, alignItems: 'stretch' }}
                >
                  {details.length > 0 ? (
                    <AgentThoughtTracePanel paragraphs={details} streaming={thoughtStreaming} />
                  ) : null}
                  {workflowSteps.length > 0 ? (
                    <Box sx={{ width: '100%', pt: details.length > 0 ? 1 : 0 }}>
                      <AIResponseLog status={workflowStatus} steps={workflowSteps} />
                    </Box>
                  ) : null}
                </Stack>
              </Collapse>
            ) : null}
        </Stack>
      </Box>
    </Stack>
  )
}
